var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"info-icon btn-base-element-icon fa fa-info-circle",attrs:{"data-html":"true","data-placement":_vm.placement,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }